import { t } from '@lingui/macro'
// import { isAuthorized } from 'helpers'

export const getTerminalRoutes = (userRoles, navigate) => {
  return [
    {
      label: t`Overview`,
      path: '/terminal/overview',
      onClick: path => navigate(path)
    },
    // {
    //   label: i18n._(t`Posts`),
    //   path: '/terminal/posts',
    //   pages: [
    // {
    //   label: i18n._(t`Corona`),
    //   path: '/terminal/posts/corona',
    //   onClick: path => navigate(path)
    // },
    {
      label: t`News`,
      path: '/terminal/posts/news',
      onClick: path => navigate(path)
    },
    {
      label: t`Articles`,
      path: '/terminal/posts/articles',
      onClick: path => navigate(path)
    },
    {
      label: t`Cases`,
      path: '/terminal/posts/cases',
      onClick: path => navigate(path)
    },
    {
      label: t`Products`,
      path: '/terminal/posts/products',
      onClick: path => navigate(path)
    },
    {
      label: t`Services`,
      path: '/terminal/posts/services',
      onClick: path => navigate(path)
    }
    //   ]
    // }
    // {
    //   label: `Intros`,
    //   path: '/terminal/introductions',
    //   pages: [
    //     {
    //       label: `Flight`,
    //       path: '/terminal/introductions/flight',
    //       onClick: path => navigate(path)
    //     },
    //     {
    //       label: `Events`,
    //       path: '/terminal/introductions/events',
    //       onClick: path => navigate(path)
    //     },
    //     {
    //       label: `Booking`,
    //       path: '/terminal/introductions/booking',
    //       onClick: path => navigate(path)
    //     },
    //     {
    //       label: `Staff`,
    //       path: '/terminal/introductions/staff',
    //       onClick: path => navigate(path)
    //     },
    //     {
    //       label: `CRM`,
    //       path: '/terminal/introductions/crm',
    //       onClick: path => navigate(path)
    //     },
    //     {
    //       label: `Loyalty`,
    //       path: '/terminal/introductions/loyalty',
    //       onClick: path => navigate(path)
    //     },
    //     {
    //       label: `Analytics`,
    //       path: '/terminal/introductions/analytics',
    //       onClick: path => navigate(path)
    //     },
    //     {
    //       label: `GDPR`,
    //       path: '/terminal/introductions/gdpr',
    //       onClick: path => navigate(path)
    //     },
    //     {
    //       label: `Seatmaps`,
    //       path: '/terminal/introductions/seatmaps',
    //       onClick: path => navigate(path)
    //     },
    //     {
    //       label: `Apps`,
    //       path: '/terminal/introductions/apps',
    //       onClick: path => navigate(path)
    //     },
    //     {
    //       label: `SSO`,
    //       path: '/terminal/introductions/sso',
    //       onClick: path => navigate(path)
    //     }
    //   ]
    // }
  ]
}
